import {
  MCP_APP_PATH,
  MCP_APPROVALS_APP_PATH,
  MCP_CONSENT_APP_PATH,
  MCP_TRANSACTION_PARAM,
  MCP_TRANSACTION_PATTERN,
  MCP_UUID_PATTERN,
} from '../constants';

interface McpFrameUrlParams {
  origin: string;
  isConsentPage: boolean;
  search: string;
  draftId?: string;
}

/** Точный https origin без пути; иначе '' — сервис считается не настроенным. */
export const getMcpResourceOrigin = (value: string): string => {
  try {
    const url = new URL(value);

    return url.protocol === 'https:' && url.origin === value ? url.origin : '';
  } catch {
    return '';
  }
};

// URLSearchParams.size нет в Chrome ≤ 112 и Safari ≤ 16 из production
// browserslist: там undefined !== 1 закрывал любую ссылку consent.
const countSearchParams = (params: URLSearchParams): number => {
  let count = 0;

  params.forEach(() => {
    count += 1;
  });

  return count;
};

/** Адрес фрейма MCP или '' для недействительной ссылки consent/approval. */
export const getMcpFrameUrl = ({
  origin,
  isConsentPage,
  search,
  draftId,
}: McpFrameUrlParams): string => {
  if (!origin) return '';

  const url = new URL(MCP_APP_PATH, origin);

  if (isConsentPage) {
    const params = new URLSearchParams(search);
    const transaction = params.get(MCP_TRANSACTION_PARAM) ?? '';

    if (
      countSearchParams(params) !== 1 ||
      !MCP_TRANSACTION_PATTERN.test(transaction)
    )
      return '';

    url.pathname = MCP_CONSENT_APP_PATH;
    url.searchParams.set(MCP_TRANSACTION_PARAM, transaction);
  } else if (draftId !== undefined) {
    if (!MCP_UUID_PATTERN.test(draftId) || search) return '';

    url.pathname = `${MCP_APPROVALS_APP_PATH}/${draftId}`;
  }

  return url.href;
};
